// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* =========================================================
   CONTENEUR PRINCIPAL
   ========================================================= */

.configManager {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #18191d;
    color: #dedfe7;
    font-family: Arial, sans-serif;
    font-size: 12px;
    box-sizing: border-box;
    overflow: hidden;
}


/* =========================================================
   ZONE DE CONTENU
   ========================================================= */

.configManagerTop {
    flex: 1 1;
    min-height: 0;
    margin: 0;
    padding: 5px 7px 8px;
    width: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.configManagerTop::-webkit-scrollbar {
    display: none;
}


/* =========================================================
   BARRE D'OUTILS INFÉRIEURE
   ========================================================= */

.configManagerBottom {
    flex-shrink: 0;
    height: 32px;
    width: 100%;
    box-sizing: border-box;
    margin-top: 0;
    border-top: 1px solid #30313a;
    background-color: #202127;
    display: flex;
    align-items: center;
}


/* =========================================================
   TITRE PRINCIPAL
   ========================================================= */

.configManagerTitle {
    width: 100%;
    box-sizing: border-box;
    margin: 0 0 12px;
    padding: 10px 10px 10px 12px;

    background: linear-gradient(
        100deg,
        #343044 0%,
        #292832 100%
    );

    border: 1px solid #454052;
    border-left: 3px solid #9182ed;
    border-radius: 5px;

    color: #f4f2ff;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.2px;
}


/* =========================================================
   CONFIGURATION ACTUELLE
   ========================================================= */

.configManagerCurrentDiv {
    width: 100%;
    box-sizing: border-box;
    margin: 0 0 16px;

    background-color: #22232a;
    border: 1px solid #363742;
    border-radius: 5px;
    overflow: hidden;

    color: #e5e5ee;
}

.configManagerCurrentDivTop {
    width: 100%;
    box-sizing: border-box;
    padding: 6px 9px 4px;

    background-color: #292a32;

    color: #a8a9bb;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.4px;
    text-align: left;
    text-transform: uppercase;
}

.configManagerCurrentDivBottom {
    width: 100%;
    box-sizing: border-box;
    padding: 8px 9px;

    background-color: #22232a;

    color: #c7beff;
    font-size: 12px;
    font-weight: 600;
    text-align: left;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}


/* =========================================================
   SOUS-TITRES / LIBELLÉS
   ========================================================= */

.configManagerSubtitle {
    width: 100%;
    box-sizing: border-box;

    margin: 10px 0 4px;
    padding: 3px 2px;

    background-color: transparent;
    border: none;

    color: #aeb0c0;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-align: left;
    text-transform: uppercase;
}


/* =========================================================
   LISTE DES CONFIGURATIONS
   ========================================================= */

.ListConfigMain {
    width: 100%;
    box-sizing: border-box;

    margin: 12px 0 0;
    padding: 4px;

    overflow-y: auto;
    overflow-x: hidden;

    scrollbar-width: none;
    -ms-overflow-style: none;

    background-color: #141519;
    border: 1px solid #30313b;
    border-radius: 5px;
}

.ListConfigMain::-webkit-scrollbar {
    display: none;
}


/* =========================================================
   ÉLÉMENTS DE LA LISTE
   ========================================================= */

.ListConfigItem {
    width: 100%;
    box-sizing: border-box;

    margin: 0 0 3px;
    padding: 5px 6px;

    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    border-radius: 4px;
    border: 1px solid transparent;

    color: #d4d5df;

    cursor: pointer;
    transition:
        background-color 120ms ease,
        border-color 120ms ease,
        color 120ms ease;
}


/* Première ligne */

.ListConfigItemLine1Even,
.ListConfigItemLine1Odd {
    box-sizing: border-box;
    padding: 2px 4px;

    font-size: 12px;
    font-weight: 500;
    line-height: 1.4;

    background-color: transparent;
    color: inherit;
}


/* Deuxième ligne */

.ListConfigItemLine2Even,
.ListConfigItemLine2Odd {
    box-sizing: border-box;
    padding: 2px 4px;

    font-size: 10px;
    line-height: 1.4;

    background-color: transparent;
    color: #9093a3;
}


/* Alternance discrète */

.ListConfigItemLine1Odd,
.ListConfigItemLine2Odd {
    background-color: transparent;
}


/* Survol */

.ListConfigItem:hover {
    background-color: #292a35;
    border-color: #414153;
    color: #f0efff;
}

.ListConfigItem:hover .ListConfigItemLine2Even,
.ListConfigItem:hover .ListConfigItemLine2Odd {
    color: #b6b7ca;
}


/* =========================================================
   ÉLÉMENT SÉLECTIONNÉ
   ========================================================= */

.ListConfigItemLine1Selected,
.ListConfigItemLine2Selected {
    box-sizing: border-box;
    padding: 2px 4px;

    background-color: transparent;
    color: #f0edff;
}

.ListConfigItemLine1Selected {
    font-size: 12px;
    font-weight: 600;
    line-height: 1.4;
}

.ListConfigItemLine2Selected {
    font-size: 10px;
    line-height: 1.4;
    color: #c1b8ff;
}


/* Conteneur de l'élément sélectionné */

.ListConfigItem:has(.ListConfigItemLine1Selected) {
    background-color: #343047;
    border-color: #61558e;
    border-left: 3px solid #9988ff;
    padding-left: 4px;
}


/* =========================================================
   COMPATIBILITÉ / ANCIENNE CLASSE
   ========================================================= */

.configManagerFull {
    margin: 0;
    padding: 0 7px;
    width: 100%;
    height: 200px;
    box-sizing: border-box;

    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.configManagerFull::-webkit-scrollbar {
    display: none;
}


.configManagerSectionTitle {
    display: flex;
    align-items: center;
    gap: 8px;

    width: 100%;
    box-sizing: border-box;

    margin: 0 0 8px;
    padding: 0 0 7px;

    border-bottom: 1px solid #34353f;

    color: #e0deef;
    font-size: 12px;
    font-weight: 600;
}

.configManagerSectionTitle::before {
    content: "";
    display: block;

    width: 3px;
    height: 13px;

    flex-shrink: 0;

    border-radius: 2px;
    background-color: #9988ff;
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/confmanager/confmanager.css"],"names":[],"mappings":";AACA;;8DAE8D;;AAE9D;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;;;AAGA;;8DAE8D;;AAE9D;IACI,SAAO;IACP,aAAa;IACb,SAAS;IACT,oBAAoB;IACpB,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;;AAGA;;8DAE8D;;AAE9D;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,6BAA6B;IAC7B,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;;AAGA;;8DAE8D;;AAE9D;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,4BAA4B;;IAE5B;;;;KAIC;;IAED,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;;IAElB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;;AAGA;;8DAE8D;;AAE9D;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;;IAEhB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;;IAEhB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,oBAAoB;;IAEpB,yBAAyB;;IAEzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;;IAEhB,yBAAyB;;IAEzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;;IAEhB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;;8DAE8D;;AAE9D;IACI,WAAW;IACX,sBAAsB;;IAEtB,kBAAkB;IAClB,gBAAgB;;IAEhB,6BAA6B;IAC7B,YAAY;;IAEZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;AAC7B;;;AAGA;;8DAE8D;;AAE9D;IACI,WAAW;IACX,sBAAsB;;IAEtB,gBAAgB;IAChB,YAAY;;IAEZ,gBAAgB;IAChB,kBAAkB;;IAElB,qBAAqB;IACrB,wBAAwB;;IAExB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;;AAGA;;8DAE8D;;AAE9D;IACI,WAAW;IACX,sBAAsB;;IAEtB,eAAe;IACf,gBAAgB;;IAEhB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;;IAEvB,kBAAkB;IAClB,6BAA6B;;IAE7B,cAAc;;IAEd,eAAe;IACf;;;wBAGoB;AACxB;;;AAGA,mBAAmB;;AAEnB;;IAEI,sBAAsB;IACtB,gBAAgB;;IAEhB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;;IAEhB,6BAA6B;IAC7B,cAAc;AAClB;;;AAGA,mBAAmB;;AAEnB;;IAEI,sBAAsB;IACtB,gBAAgB;;IAEhB,eAAe;IACf,gBAAgB;;IAEhB,6BAA6B;IAC7B,cAAc;AAClB;;;AAGA,wBAAwB;;AAExB;;IAEI,6BAA6B;AACjC;;;AAGA,WAAW;;AAEX;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;;AAGA;;8DAE8D;;AAE9D;;IAEI,sBAAsB;IACtB,gBAAgB;;IAEhB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;;AAGA,uCAAuC;;AAEvC;IACI,yBAAyB;IACzB,qBAAqB;IACrB,8BAA8B;IAC9B,iBAAiB;AACrB;;;AAGA;;8DAE8D;;AAE9D;IACI,SAAS;IACT,cAAc;IACd,WAAW;IACX,aAAa;IACb,sBAAsB;;IAEtB,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;;IAER,WAAW;IACX,sBAAsB;;IAEtB,eAAe;IACf,gBAAgB;;IAEhB,gCAAgC;;IAEhC,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;;IAEd,UAAU;IACV,YAAY;;IAEZ,cAAc;;IAEd,kBAAkB;IAClB,yBAAyB;AAC7B","sourcesContent":["\n/* =========================================================\n   CONTENEUR PRINCIPAL\n   ========================================================= */\n\n.configManager {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    background-color: #18191d;\n    color: #dedfe7;\n    font-family: Arial, sans-serif;\n    font-size: 12px;\n    box-sizing: border-box;\n    overflow: hidden;\n}\n\n\n/* =========================================================\n   ZONE DE CONTENU\n   ========================================================= */\n\n.configManagerTop {\n    flex: 1;\n    min-height: 0;\n    margin: 0;\n    padding: 5px 7px 8px;\n    width: 100%;\n    box-sizing: border-box;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n}\n\n.configManagerTop::-webkit-scrollbar {\n    display: none;\n}\n\n\n/* =========================================================\n   BARRE D'OUTILS INFÉRIEURE\n   ========================================================= */\n\n.configManagerBottom {\n    flex-shrink: 0;\n    height: 32px;\n    width: 100%;\n    box-sizing: border-box;\n    margin-top: 0;\n    border-top: 1px solid #30313a;\n    background-color: #202127;\n    display: flex;\n    align-items: center;\n}\n\n\n/* =========================================================\n   TITRE PRINCIPAL\n   ========================================================= */\n\n.configManagerTitle {\n    width: 100%;\n    box-sizing: border-box;\n    margin: 0 0 12px;\n    padding: 10px 10px 10px 12px;\n\n    background: linear-gradient(\n        100deg,\n        #343044 0%,\n        #292832 100%\n    );\n\n    border: 1px solid #454052;\n    border-left: 3px solid #9182ed;\n    border-radius: 5px;\n\n    color: #f4f2ff;\n    font-size: 14px;\n    font-weight: 600;\n    letter-spacing: 0.2px;\n}\n\n\n/* =========================================================\n   CONFIGURATION ACTUELLE\n   ========================================================= */\n\n.configManagerCurrentDiv {\n    width: 100%;\n    box-sizing: border-box;\n    margin: 0 0 16px;\n\n    background-color: #22232a;\n    border: 1px solid #363742;\n    border-radius: 5px;\n    overflow: hidden;\n\n    color: #e5e5ee;\n}\n\n.configManagerCurrentDivTop {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 6px 9px 4px;\n\n    background-color: #292a32;\n\n    color: #a8a9bb;\n    font-size: 10px;\n    font-weight: 600;\n    letter-spacing: 0.4px;\n    text-align: left;\n    text-transform: uppercase;\n}\n\n.configManagerCurrentDivBottom {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 8px 9px;\n\n    background-color: #22232a;\n\n    color: #c7beff;\n    font-size: 12px;\n    font-weight: 600;\n    text-align: left;\n\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n\n/* =========================================================\n   SOUS-TITRES / LIBELLÉS\n   ========================================================= */\n\n.configManagerSubtitle {\n    width: 100%;\n    box-sizing: border-box;\n\n    margin: 10px 0 4px;\n    padding: 3px 2px;\n\n    background-color: transparent;\n    border: none;\n\n    color: #aeb0c0;\n    font-size: 10px;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    text-align: left;\n    text-transform: uppercase;\n}\n\n\n/* =========================================================\n   LISTE DES CONFIGURATIONS\n   ========================================================= */\n\n.ListConfigMain {\n    width: 100%;\n    box-sizing: border-box;\n\n    margin: 12px 0 0;\n    padding: 4px;\n\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n\n    background-color: #141519;\n    border: 1px solid #30313b;\n    border-radius: 5px;\n}\n\n.ListConfigMain::-webkit-scrollbar {\n    display: none;\n}\n\n\n/* =========================================================\n   ÉLÉMENTS DE LA LISTE\n   ========================================================= */\n\n.ListConfigItem {\n    width: 100%;\n    box-sizing: border-box;\n\n    margin: 0 0 3px;\n    padding: 5px 6px;\n\n    text-align: left;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    border-radius: 4px;\n    border: 1px solid transparent;\n\n    color: #d4d5df;\n\n    cursor: pointer;\n    transition:\n        background-color 120ms ease,\n        border-color 120ms ease,\n        color 120ms ease;\n}\n\n\n/* Première ligne */\n\n.ListConfigItemLine1Even,\n.ListConfigItemLine1Odd {\n    box-sizing: border-box;\n    padding: 2px 4px;\n\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.4;\n\n    background-color: transparent;\n    color: inherit;\n}\n\n\n/* Deuxième ligne */\n\n.ListConfigItemLine2Even,\n.ListConfigItemLine2Odd {\n    box-sizing: border-box;\n    padding: 2px 4px;\n\n    font-size: 10px;\n    line-height: 1.4;\n\n    background-color: transparent;\n    color: #9093a3;\n}\n\n\n/* Alternance discrète */\n\n.ListConfigItemLine1Odd,\n.ListConfigItemLine2Odd {\n    background-color: transparent;\n}\n\n\n/* Survol */\n\n.ListConfigItem:hover {\n    background-color: #292a35;\n    border-color: #414153;\n    color: #f0efff;\n}\n\n.ListConfigItem:hover .ListConfigItemLine2Even,\n.ListConfigItem:hover .ListConfigItemLine2Odd {\n    color: #b6b7ca;\n}\n\n\n/* =========================================================\n   ÉLÉMENT SÉLECTIONNÉ\n   ========================================================= */\n\n.ListConfigItemLine1Selected,\n.ListConfigItemLine2Selected {\n    box-sizing: border-box;\n    padding: 2px 4px;\n\n    background-color: transparent;\n    color: #f0edff;\n}\n\n.ListConfigItemLine1Selected {\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.4;\n}\n\n.ListConfigItemLine2Selected {\n    font-size: 10px;\n    line-height: 1.4;\n    color: #c1b8ff;\n}\n\n\n/* Conteneur de l'élément sélectionné */\n\n.ListConfigItem:has(.ListConfigItemLine1Selected) {\n    background-color: #343047;\n    border-color: #61558e;\n    border-left: 3px solid #9988ff;\n    padding-left: 4px;\n}\n\n\n/* =========================================================\n   COMPATIBILITÉ / ANCIENNE CLASSE\n   ========================================================= */\n\n.configManagerFull {\n    margin: 0;\n    padding: 0 7px;\n    width: 100%;\n    height: 200px;\n    box-sizing: border-box;\n\n    overflow-y: auto;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n}\n\n.configManagerFull::-webkit-scrollbar {\n    display: none;\n}\n\n\n.configManagerSectionTitle {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    width: 100%;\n    box-sizing: border-box;\n\n    margin: 0 0 8px;\n    padding: 0 0 7px;\n\n    border-bottom: 1px solid #34353f;\n\n    color: #e0deef;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.configManagerSectionTitle::before {\n    content: \"\";\n    display: block;\n\n    width: 3px;\n    height: 13px;\n\n    flex-shrink: 0;\n\n    border-radius: 2px;\n    background-color: #9988ff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
